<header class="header">
  <div class="header-content">
    <!-- Menu Hamburguer (apenas mobile) -->
    <button class="hamburger-menu" (click)="toggleMobileMenu()" [class.active]="showMobileMenu">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div class="logo-container">
      <img [src]="getLogoImage()" alt="Logo" class="logo" [routerLink]="getLogoRouterLink()"
        [style.cursor]="getLogoCursor()" appTrackClick
        [trackEvent]="isInReportsRoute() ? 'plataforma_reports' : 'plataforma_leads'" trackCategory="navigation"
        [trackLabel]="isInReportsRoute() ? 'logo_reports_click' : 'logo_leads_click'">
    </div>

    <!-- Menu mobile overlay -->
    <div class="mobile-menu-overlay" *ngIf="showMobileMenu" (click)="closeMobileMenu()"></div>

    <div class="mobile-menu" [class.open]="showMobileMenu">
      <div class="mobile-menu-header">
        <div class="mobile-logo-container">
          <img [src]="getLogoImage()" alt="Logo" class="mobile-logo">
        </div>
        <button class="mobile-menu-close" (click)="closeMobileMenu()">×</button>
      </div>

      <div class="mobile-menu-content">
        <!-- Usuário + Seletor de DN (mobile com modal) -->
        <div class="mobile-unit-selector">
          <div class="mobile-user-greeting">Olá, {{this.user?.name}}</div>
          <div class="mobile-unit-section">
            <!-- Botão que abre o modal -->
            <button class="mobile-unit-button" (click)="openDnModal()">
              <span class="unit-display">
                {{ getSelectedDealershipName() }}
              </span>
              <img src="assets/icons/arrowDownCalendar.png" alt="Selecionar" class="dropdown-icon">
            </button>
          </div>
        </div>

        <!-- Ícone de Radar -->
        <div class="mobile-menu-item" (click)="navigateToRadar(); closeMobileMenu()">
          <img src="assets/icons/radarIcon.png" alt="Conversão" class="mobile-menu-icon">
          <span>Plataforma Digital</span>
        </div>

        <!-- Ícone de Calendário (aparece APENAS quando shouldShowCalendar() for true = rota leads) -->
        <div class="mobile-menu-item" *ngIf="shouldShowCalendar()" (click)="toggleCalendarPopup(); closeMobileMenu()">
          <img src="/assets/icons/calendar.png" alt="Calendário" class="mobile-menu-icon">
          <span>Calendário</span>
        </div>

        <!-- Admin Panel (se disponível e não estiver em admin/reports) -->
        <div class="mobile-menu-item" *ngIf="shouldShowAdminPanelIcon()" [routerLink]="'/admin-panel'"
          (click)="closeMobileMenu()">
          <img src="assets/icons/adminPositiveLogo.png" alt="Admin Panel" class="mobile-menu-icon">
          <span>Admin</span>
        </div>
      </div>
    </div>

    <div class="icons-container">
      <!-- Seletor de Unidades à esquerda do calendário (apenas desktop) -->
      <div class="unit-selector-header">
        <div class="user-greeting">Olá, {{this.user?.name}}</div>
        <div class="unit-section">
          <select class="unit-dropdown" [ngModel]="selectedUnit" (ngModelChange)="onUnitChangeModel($event)">
            <optgroup *ngFor="let manufacturer of user?.montadoras" [label]="manufacturer.nome">
              <option *ngFor="let dealership of manufacturer.concessionarias" [value]="dealership.codigo">
                {{ dealership.codigo.toString().padStart(5, '0') }} - {{ dealership.nome }}
              </option>
            </optgroup>
          </select>
        </div>
      </div>

      <div class="calendar-container" *ngIf="shouldShowCalendar()" matTooltip="Lembretes">
        <img src="/assets/icons/calendar.png" alt="Calendário" class="icon-calendar" (click)="toggleCalendarPopup()"
          appTrackClick [trackEvent]="isInReportsRoute() ? 'calendario_reports' : 'calendario_leads'"
          trackCategory="header" [trackLabel]="isInReportsRoute() ? 'calendar_reports_icon' : 'calendar_leads_icon'">

        <!-- Popup de Calendário Desktop -->
        <div class="calendar-popup" *ngIf="showCalendarPopup && !isMobile" matTooltip="Lembrete">
          <div class="popup-content">
            <div class="popup-header">
              <h2 class="popup-title">Lembretes</h2>
              <button class="close-btn" (click)="closeCalendarPopup()">×</button>
            </div>

            <div class="divider"></div>

            <!-- Estado de loading -->
            <div *ngIf="loading" class="loading-state">
              <div class="loading-spinner"></div>
              <p>Carregando agendamentos...</p>
            </div>

            <!-- Estado de erro -->
            <div *ngIf="error && !loading" class="error-state">
              <div class="error-icon">⚠️</div>
              <p>Erro ao carregar agendamentos</p>
              <button class="retry-btn" (click)="loadAppointments()">Tentar novamente</button>
            </div>

            <!-- Conteúdo normal -->
            <div *ngIf="!loading && !error">
              <div *ngIf="hasNoAppointments()" class="no-appointments">
                <div class="no-appointments-icon">📅</div>
                <p class="no-appointments-text">Nenhum agendamento pendente.</p>
              </div>

              <div *ngIf="hasAppointmentsData() && getTodayTotal() > 0" class="section">
                <div class="section-header">
                  <h3 class="section-title today">Agendados para hoje</h3>
                  <button class="view-all-btn" (click)="viewTodayAll()">Ver todos</button>
                </div>
                <div class="count">{{ getTodayTotal() }} atividades</div>
                <div class="schedule-list">
                  <div class="schedule-item" *ngFor="let item of getTodaySchedules()"
                    (click)="navigateToLeadDetails(item)">
                    <span class="schedule-name">{{ item.nomeCliente }}, {{ formatHorario(item) }}</span>
                    <img src="assets/icons/arrowRightCalendar.png" alt="Ver" class="arrow-icon">
                  </div>
                </div>
              </div>

              <div *ngIf="hasAppointmentsData() && getUpcomingTotal() > 0" class="section">
                <div class="section-header">
                  <h3 class="section-title upcoming">Próximos Agendamentos</h3>
                  <button class="view-all-btn" (click)="viewUpcomingAll()">Ver todos</button>
                </div>
                <div class="count-next">{{ getUpcomingTotal() }} atividades</div>
              </div>

              <div *ngIf="hasAppointmentsData() && getPastTotal() > 0" class="section">
                <div class="section-header">
                  <h3 class="section-title past">Agendamentos Passados</h3>
                  <button class="view-all-btn" (click)="viewPastAll()">Ver todos</button>
                </div>
                <div class="count-next">{{ getPastTotal() }} atividades</div>
              </div>
            </div>

            <div class="divider" *ngIf="!loading && !error && !hasNoAppointments()"></div>

            <div class="agenda-button-section" *ngIf="!loading && !error">
              <button class="agenda-button" (click)="viewAgenda()">Ver agenda</button>
            </div>
          </div>
        </div>
      </div>

      <a href="/assets/docs/guia-api-plataforma-digital-leads.pdf" target="_blank">
        <img src="assets/icons/Question.svg" matTooltip="Guia Rápido do Usuário" alt="Guia Rápido do Usuário"
          class="icon" style="margin-top: 6px;">
      </a>

      <a [routerLink]="'/documentacao-api'" target="_blank">
        <img src="assets/icons/file-code.svg" matTooltip="Documentação API" alt="Documentação API" class="icon" style="margin-top: 6px;">
      </a>

      <img src="assets/icons/radarIcon.png" alt="Conversão" class="icon" (click)="navigateToRadar()"
        [style.cursor]="'pointer'" appTrackClick [trackEvent]="isInReportsRoute() ? 'digital_reports' : 'digital_leads'"
        trackCategory="header" [trackLabel]="isInReportsRoute() ? 'radar_reports_icon' : 'radar_leads_icon'"
        matTooltip="Logout">

      <img *ngIf="shouldShowAdminPanelIcon()" src="assets/icons/adminPositiveLogo.png" alt="Admin Panel" class="icon"
        [routerLink]="'/admin-panel'" [style.cursor]="'pointer'" appTrackClick
        [trackEvent]="isInReportsRoute() ? 'admin_reports' : 'admin_leads'" trackCategory="header"
        [trackLabel]="isInReportsRoute() ? 'admin_reports_icon' : 'admin_leads_icon'">
    </div>
  </div>

  <!-- Popup de Calendário Mobile (tela cheia) -->
  <div class="calendar-popup-fullscreen" *ngIf="showCalendarPopup && isMobile">
    <div class="popup-fullscreen-content">
      <div class="popup-fullscreen-header">
        <h2 class="popup-fullscreen-title">Lembretes</h2>
        <button class="close-fullscreen-btn" (click)="closeCalendarPopup()">×</button>
      </div>

      <div class="divider-fullscreen"></div>

      <!-- Estado de loading -->
      <div *ngIf="loading" class="loading-state-fullscreen">
        <div class="loading-spinner-fullscreen"></div>
        <p>Carregando agendamentos...</p>
      </div>

      <!-- Estado de erro -->
      <div *ngIf="error && !loading" class="error-state-fullscreen">
        <div class="error-icon-fullscreen">⚠️</div>
        <p>Erro ao carregar agendamentos</p>
        <button class="retry-btn-fullscreen" (click)="loadAppointments()">Tentar novamente</button>
      </div>

      <!-- Conteúdo normal -->
      <div *ngIf="!loading && !error" class="popup-fullscreen-body">
        <div *ngIf="hasNoAppointments()" class="no-appointments-fullscreen">
          <div class="no-appointments-icon-fullscreen">📅</div>
          <p class="no-appointments-text-fullscreen">Nenhum agendamento pendente.</p>
        </div>

        <div *ngIf="hasAppointmentsData() && getTodayTotal() > 0" class="section-fullscreen">
          <div class="section-header-fullscreen">
            <h3 class="section-title-fullscreen today">Agendados para hoje</h3>
            <button class="view-all-btn-fullscreen" (click)="viewTodayAll()">Ver todos</button>
          </div>
          <div class="count-fullscreen">{{ getTodayTotal() }} atividades</div>
          <div class="schedule-list-fullscreen">
            <div class="schedule-item-fullscreen" *ngFor="let item of getTodaySchedules()"
              (click)="navigateToLeadDetails(item)">
              <span class="schedule-name-fullscreen">{{ item.nomeCliente }}, {{ formatHorario(item) }}</span>
              <img src="assets/icons/arrowRightCalendar.png" alt="Ver" class="arrow-icon-fullscreen">
            </div>
          </div>
        </div>

        <div *ngIf="hasAppointmentsData() && getUpcomingTotal() > 0" class="section-fullscreen">
          <div class="section-header-fullscreen">
            <h3 class="section-title-fullscreen upcoming">Próximos Agendamentos</h3>
            <button class="view-all-btn-fullscreen" (click)="viewUpcomingAll()">Ver todos</button>
          </div>
          <div class="count-next-fullscreen">{{ getUpcomingTotal() }} atividades</div>
        </div>

        <div *ngIf="hasAppointmentsData() && getPastTotal() > 0" class="section-fullscreen">
          <div class="section-header-fullscreen">
            <h3 class="section-title-fullscreen past">Agendamentos Passados</h3>
            <button class="view-all-btn-fullscreen" (click)="viewPastAll()">Ver todos</button>
          </div>
          <div class="count-next-fullscreen">{{ getPastTotal() }} atividades</div>
        </div>
      </div>

      <div class="divider-fullscreen" *ngIf="!loading && !error && !hasNoAppointments()"></div>

      <div class="agenda-button-section-fullscreen" *ngIf="!loading && !error">
        <button class="agenda-button-fullscreen" (click)="viewAgenda()">Ver agenda</button>
      </div>
    </div>
  </div>

  <!-- Modal para seleção de DN (Mobile) -->
  <div class="dn-picker-modal" *ngIf="showDnModal" [class.active]="showDnModal">
    <div class="modal-overlay" (click)="closeDnModal()"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h3>Selecionar Concessionária</h3>
        <button class="close-button" (click)="closeDnModal()">✕</button>
      </div>

      <div class="modal-body">
        <div class="dn-list">
          <div *ngFor="let manufacturer of user?.montadoras" class="manufacturer-group">
            <div class="manufacturer-title">{{ manufacturer.nome }}</div>
            <div class="dealership-list">
              <div *ngFor="let dealership of manufacturer.concessionarias" class="dealership-item"
                [class.selected]="selectedUnit === dealership.codigo.toString()"
                (click)="selectDnFromModal(dealership.codigo.toString())">
                <span class="dealership-code">{{ dealership.codigo.toString().padStart(5, '0') }}</span>
                <span class="dealership-name">{{ dealership.nome }}</span>
                <div class="radio-indicator" *ngIf="selectedUnit === dealership.codigo.toString()">
                  <div class="radio-dot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="button-cancel" (click)="closeDnModal()">Cancelar</button>
        <button class="button-confirm" (click)="confirmDnSelection()">Confirmar</button>
      </div>
    </div>
  </div>
</header>
